// extracted by mini-css-extract-plugin
export var divider = "Divider-module--divider--3BsB_";